import { Button, Col, Icon, Input, Modal, Row, Table } from "antd";
import Column from "antd/lib/table/Column";
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import useWindowSize from "../../../hooks/useWindowSize";
import { searchSupplementByName } from "../../../services/supplementService";

// import { Container } from './styles';

function ModalSelectSupplement({
  pageData,
  visible,
  handleSelect,
  handleCancel,
}) {
  const { width } = useWindowSize();
  const [selectedRowsKeys, setSelectedRowKeys] = useState([]);
  const onSelectRowTable = {
    type: "radio",
    selectedRowKeys: selectedRowsKeys,
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      if (selected) {
        setSelectedRowKeys((old) => [record.id]);
      } else {
        setSelectedRowKeys((old) => old.filter((r) => r !== record.id));
      }
    },
    onSelectAll: (record, selected, selectedRows, nativeEvent) => {
      // Get just the ids
      const keys = selectedRows.map((sr) => sr.id);
      // Get all the selectedAnimalsKeys unless the unselected
      const lastSelectedAnimalsKeys = selectedRowsKeys.filter(
        (sAK) => !keys.includes(sAK),
      );
      if (record) {
        setSelectedRowKeys((old) => [...keys]);
      } else {
        setSelectedRowKeys(lastSelectedAnimalsKeys);
      }
    },
  };
  const { translation } = useSelector((state) => state.app);

  return (
    <Modal
      width={width >= 1440 ? 1000 : 800}
      title={"Selecione um suplemento"}
      centered
      visible={visible}
      okText={translation.buttons.confirm}
      onCancel={handleCancel}
      zIndex={1011}
      onOk={() =>
        handleSelect(
          selectedRowsKeys.length > 0
            ? selectedRowsKeys[selectedRowsKeys.length - 1]
            : null,
        )
      }
    >
      <Table
        rowKey="id"
        size="small"
        rowSelection={onSelectRowTable}
        dataSource={pageData != null ? pageData : []}
        scroll={{
          x: true,
        }}
        style={{ width: "100%", margin: "0" }}
      >
        <Column
          title={translation.supplement.table.columns.description}
          dataIndex="name"
          align="left"
          key="name"
        />
        <Column
          title={translation.supplement.table.columns.industrialName}
          dataIndex="industrialName"
          align="left"
          key="industrialName"
        />
        <Column
          title={translation.supplement.table.columns.supplementGroupName}
          dataIndex="supplementGroupName"
          key="supplementGroupName"
          align="left"
        />
        <Column
          title={translation.supplement.table.columns.supplementSubGroupName}
          dataIndex="supplementSubGroupName"
          key="supplementSubGroupName"
          align="left"
        />
        <Column
          title={
            translation.supplement.table.columns.supplementPresentationName
          }
          dataIndex="supplementPresentationName"
          key="supplementPresentationName"
          align="left"
        />
        <Column
          title={translation.supplement.table.columns.supplierName}
          dataIndex="supplierName"
          align="left"
          key="supplierName"
        />
      </Table>
    </Modal>
  );
}

function SearchSupplement({
  textSearch,
  setTextSearch,
  value,
  handleChange,
  handleDeselect,
  showDeselect = false,
  searchFormulationIngredients = false,
  excludeSupplementId = null,
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const handleSearch = useCallback(async () => {
    if (textSearch) {
      setIsLoading(true);
      try {
        const {
          data: { results },
        } = await searchSupplementByName({
          groupId,
          farmId,
          name: textSearch,
          searchFormulationIngredients,
        });
        setData(
          excludeSupplementId
            ? (results || []).filter((item) => item.id !== excludeSupplementId)
            : results,
        );
        setModalVisible(true);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else {
      setData([]);
    }
  }, [
    excludeSupplementId,
    farmId,
    groupId,
    searchFormulationIngredients,
    textSearch,
  ]);

  const handleCancelModal = () => {
    setModalVisible(false);
    setData([]);
    setTextSearch(null);
    handleChange(null, null);
  };

  const handleSelectModal = (value) => {
    setModalVisible(false);
    const supplementSelected = data.find((s) => s.id === value);
    setTextSearch(supplementSelected.name);
    handleChange(value, supplementSelected);
  };

  const handleDeselectModal = () => {
    setModalVisible(false);
    const supplementSelected = data.find((s) => s.id === value);
    setTextSearch(null);
    setData([]);
    handleDeselect(supplementSelected);
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent form submission
      handleSearch();
    }
  };

  return (
    <div>
      <Row type="flex" gutter={8}>
        <Col span={showDeselect ? 20 : 22}>
          <Input
            placeholder={translation.defaultPlaceholder}
            disabled={isLoading}
            value={textSearch}
            onKeyDown={handleEnter}
            onChange={(e) => setTextSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          {isLoading ? (
            <Icon type="loading" />
          ) : (
            <Button shape="circle" icon="search" onClick={handleSearch} />
          )}
        </Col>
        {showDeselect && value && (
          <Col span={2}>
            {!isLoading && (
              <Button
                shape="circle"
                icon="close"
                onClick={handleDeselectModal}
              />
            )}
          </Col>
        )}
      </Row>
      <ModalSelectSupplement
        pageData={data}
        visible={modalVisible}
        handleSelect={handleSelectModal}
        handleCancel={handleCancelModal}
      />
    </div>
  );
}

export default SearchSupplement;
